import React from 'react';
import { useDispatch } from 'react-redux';
import { changePageNumber } from '../../features/products/productSlice';
import {
  Pagination,
  PaginationContent,
  PaginationPrevious,
  PaginationNext,
  PaginationLink,
  PaginationItem,
  PaginationEllipsis
} from './pagination';

const PaginationProductBox = ({ currentPage, numberOfPages, need }) => {
  const dispatch = useDispatch();

  const setPageNumber = (page) => {
    if (page >= 1 && page <= numberOfPages) {
      if (need === "Sell") {
        localStorage.setItem('sellPageNo', page);
      } else {
        localStorage.setItem('requestPageNo', page);
      }
      localStorage.setItem('pageNo', page);
      dispatch(changePageNumber(page));
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    if (numberOfPages <= 5) {
      for (let i = 1; i <= numberOfPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, 5);
      } else if (currentPage >= numberOfPages - 2) {
        pages.push(numberOfPages - 4, numberOfPages - 3, numberOfPages - 2, numberOfPages - 1, numberOfPages);
      } else {
        pages.push(currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2);
      }
    }
    return pages;
  };

  const renderEllipsis = (position) => {
    if (position === 'start' && currentPage > 3) {
      return <PaginationEllipsis key="start-ellipsis" />;
    }
    if (position === 'end' && currentPage < numberOfPages - 2) {
      return <PaginationEllipsis key="end-ellipsis" />;
    }
    return null;
  };

  return (
    <Pagination className="my-custom-pagination-class mt-9 *:select-none">
      <PaginationContent>
        <PaginationPrevious
          onClick={() => setPageNumber(currentPage - 1)}
          className={`${Number(currentPage) === 1 ? 'disabled text-neutral-400 hover:text-neutral-400 cursor-default hover:bg-transparent' : 'cursor-pointer'}`}
          disabled={Number(currentPage) === 1}
        />
        {renderEllipsis('start')}
        {getPageNumbers().map((page) => (
          <PaginationItem key={page}>
            <PaginationLink
              isActive={page === currentPage}
              onClick={() => setPageNumber(page)}
              className="cursor-pointer"
            >
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}
        {/* {numberOfPages > 5 && currentPage < numberOfPages - 2 && (
          <PaginationEllipsis />
        )} */}
        {renderEllipsis('end')}
        <PaginationNext
          onClick={() => setPageNumber(currentPage + 1)}
          className={`${Number(currentPage) === Number(numberOfPages) ? 'disabled text-neutral-400 hover:text-neutral-400 cursor-default hover:bg-transparent' : 'cursor-pointer'}`}
          disabled={Number(currentPage) === Number(numberOfPages)}
        />
      </PaginationContent>
    </Pagination>
  );
};

export default PaginationProductBox;
